<template>

  <el-main
    class="main_content"
    style="padding: 0"
  >
    <div class="cont_navs_header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a @click="backList">通用管理</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>编辑规则</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="contain_div">
      <ul class="cont_btns1">
        <li>
          <el-button
            @click="backList"
            type="primary"
          >返回规则列表</el-button>
        </li>
      </ul>
      <div class="contain_header1 clr">
        <el-form
          style="width:850px;"
          ref="form"
          :model="form"
          label-width="200px"
          :rules="addFormRule"
        >

          <el-form-item
            label="代理类型"
            prop="roleType"
          >
            <el-select
              disabled
              v-model="form.roleType"
              placeholder="请选择"
            >
              <el-option
                v-for="option in typeOptions"
                :value="option.value"
                :key='option.value'
                :label="option.text"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="联盟店类型" v-if="form.roleType==1">
            <el-select
              disabled
              v-model="form.provinceType"
              placeholder="请选择"
            >
              <el-option
                label="全部"
                value="3"
              ></el-option>
              <el-option
                label="康减康庭系列联盟店"
                value="4"
              ></el-option>
              <el-option
                label="康颜单项联盟店"
                value="5"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            v-if="form.roleType==2 || form.roleType==3  || form.roleType==4 || form.roleType== 2.1  || form.roleType==3.1 || form.roleType==4.2  || form.roleType==4.8 || form.roleType==5.1"
            label="保证金"
            prop="deposit"
          >
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.deposit"
              style="width:70%"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="升级购物金额"
            prop="payMoney"
          >
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.payMoney"
              style="width:70%"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="代理最低下单金额"
            prop="lowMoney"
          >
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.lowMoney"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-if="form.roleType!=-0.5"
            label="康减系列VIP会员升级金额"
            prop="unitMoney"
          >
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.unitMoney"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-if="form.roleType!=-0.4 && form.roleType!=-0.5"
            label="康减系列高级会员升级金额"
            prop="unitSecondPrice"
          >
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.unitSecondPrice"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-if="form.roleType!=-0.3 && form.roleType!=-0.4 && form.roleType!=-0.5"
            label="康减系列荣誉会员升级金额"
            prop="unitThreePrice"
          >
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.unitThreePrice"
              style="width:70%"
            ></el-input>
          </el-form-item>



          <el-form-item
            v-if="form.roleType!=-0.3 && form.roleType!=-0.4 && form.roleType!=-0.5 && form.roleType!=0 && form.roleType!=1 && form.roleType!=1.1"
            label="康减系列市代升级金额"
            prop="unitCityMoney"
          >
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.unitCityMoney"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-if="form.roleType==3 || form.roleType==4 || form.roleType==2.2 || form.roleType==4.2 || form.roleType==4.8"
            label="合伙人升级金额"
            prop="newProvinceMoney"
          >
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.newProvinceMoney"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-if="form.roleType==4.2 || form.roleType==4.8"
            label="董事升级金额"
            prop="newCeoMoney"
          >
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.newCeoMoney"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item
          v-if="form.roleType==4.8" 
            label="经销商升级金额"
            prop="xingRoleMoney"
          >
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.xingRoleMoney"
              style="width:70%"
            ></el-input>
          </el-form-item>


          <el-form-item
            v-if="form.roleType==3 || form.roleType==3.1 || form.roleType==4 || form.roleType==4.2 || form.roleType==4.8"
            label="康减系列省代升级金额"
            prop="unitProvinceMoney"
          >
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.unitProvinceMoney"
              style="width:70%"
            ></el-input>
          </el-form-item>


          <el-form-item
            v-if="form.roleType == 4 || form.roleType==4.2 || form.roleType==4.8"
            label="康减系列CEO升级金额"
            prop="unitCEOMoney"
          >
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.unitCEOMoney"
              style="width:70%"
            ></el-input>
          </el-form-item>



          <el-form-item
            v-if="form.roleType== 1 || form.roleType==1.05 || form.roleType==2 || form.roleType==3 || form.roleType==4 || form.roleType==4.2 || form.roleType==2.2 || form.roleType==4.8"
            label="VIP门店升级金额"
            prop="districtMoney"
          >
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.districtMoney"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-if="form.roleType== 1.05 || form.roleType==2 || form.roleType==3 || form.roleType==4 || form.roleType==4.2 || form.roleType==2.2 || form.roleType==4.8"
            label="联盟店升级金额"
            prop="cityMoney"
          >
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.cityMoney"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-if="form.roleType==2 || form.roleType==3 || form.roleType==4 || form.roleType==4.2 || form.roleType==2.2 || form.roleType==4.8"
            label="优秀高级升级金额"
            prop="niceDisMoney"
          >
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.niceDisMoney"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-if="form.roleType==3 || form.roleType==4 || form.roleType==4.2 || form.roleType==2.2 || form.roleType==4.8"
            label="市代升级金额"
            prop="provinceMoney"
          >
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.provinceMoney"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-if="form.roleType==4 || form.roleType==4.2 || form.roleType==4.8"
            label="省代升级金额"
            prop="ceoMoney"
          >
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.ceoMoney"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item
            v-if="form.roleType==2 || form.roleType==3 || form.roleType==4 || form.roleType== 2.1 || form.roleType== 3.1 || form.roleType== 4.2 || form.roleType==4.8 || form.roleType== 2.2"
            label="保证金描述"
            prop="depositMsg"
          >
            <el-input
              type="textarea"
              v-model="form.depositMsg"
              style="width:70%"
            ></el-input>
          </el-form-item>


          <el-form-item
            v-for="(domain, index) in form.domains"
            :label="'商品' + index"
            :key="domain.key"
            :prop="'domains.' + index + '.infoId'"
            :rules="{
              required: true, message: '商品不能为空', trigger: 'blur'
            }"
          >
            <div  style="display:flex">
            <el-input v-model="domain.infoId"  type="number"></el-input>
            <span style="display: inline-block; width: 100px;margin-left: 10px;">数量:</span>
            <el-input v-model="domain.goodNum" type="number"></el-input>
            </div>
            <el-button @click.prevent="removeDomain(domain)">删除</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="addDomain">新增赠送商品</el-button>
          </el-form-item>

          <!-- <el-form-item label="保证金协议">
            <UEditor
              :config=config
              ref="ueditor"
            ></UEditor>
          </el-form-item> -->

          

          <el-form-item
            label="学习积分"
            prop="sendIntegral"
          >
            <el-input
              oninput="value=value.replace(/[^0-9.]/g,'')"
              v-model="form.sendIntegral"
              style="width:70%"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              type="primary"
              @click="onSubmit('form')"
              :loading="addLoading"
            >{{wordName}}</el-button>
            <el-button @click="resetForm('form')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

    </div>

  </el-main>
</template>

<script>
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import { bus } from "../../bus.js";
import API from "../../api/api_user";
import { dateFunc } from "../../dateFunc.js";
import UEditor from "@/components/ueditor.vue";
var _ = require("lodash");
export default {
  name: "editUpRule",
  components: { UEditor },
  data() {
    return {
      config: {
        //可以在此处定义工具栏的内容
        // toolbars: [
        //  ['fullscreen', 'undo', 'redo','|','bold', 'italic', 'underline',
        //  '|','superscript','subscript','|', 'insertorderedlist', 'insertunorderedlist',
        //  '|','fontfamily','fontsize','justifyleft','justifyright','justifycenter','justifyjustify']
        // ],
        autoHeightEnabled: false,
        autoFloatEnabled: true,
        initialContent: "请输入内容", //初始化编辑器的内容,也可以通过textarea/script给值，看官网例子
        autoClearinitialContent: true, //是否自动清除编辑器初始内容，注意：如果focus属性设置为true,这个也为真，那么编辑器一上来就会触发导致初始化的内容看不到了
        initialFrameWidth: null,
        initialFrameHeight: 450,
        BaseUrl: "",
        UEDITOR_HOME_URL: "/static/ueditor/"
      },
      options: [{ text: "显示", value: "1" }, { text: "不显示", value: "0" }],
      typeOptions: [
        { text: "康减系列vip会员", value: "-0.5" },
        { text: "康减系列高级会员", value: "-0.4" },
        { text: "康减系列荣誉会员", value: "-0.3" },
        { text: "康减系列市代", value: "1.1" },
        { text: "优秀联盟店", value: "1.05" },
        { text: "康减系列省代", value: "2.1" },
        { text: "康减系列CEO", value: "3.1" },
        { text: "VIP门店", value: "0" },
        { text: "联盟店", value: "1" },
        { text: "市代", value: "2" },
        { text: "省代", value: "3" },
        { text: "CEO", value: "4" },
        { text: "合伙人", value: "2.2" },
        { text: "董事", value: "4.2" },
        { text: "经销商", value: "4.8" }
      ],
      tokenData: {
        token: localStorage.getItem("api_token")
      },
      good: null,
      wordName: "新增",
      addFormRule: {
        lowMoney: [
          { required: true, message: "请填写代理最低下单金额", trigger: "blur" }
        ],
        roleType: [
          { required: true, message: "请选择代理类型", trigger: "blur" }
        ],
        deposit: [
          { required: true, message: "请填写代理保证金", trigger: "blur" }
        ],
        payMoney: [
          { required: true, message: "请填写代理升级购物金额", trigger: "blur" }
        ],
        // content: [
        //   { required: true, message: "请填写协议内容", trigger: "blur" }
        // ],
        depositMsg: [
          { required: true, message: "请填写保证金描述", trigger: "blur" }
        ]
      },
      addLoading: false,
      form: {
        domains: [],
        unitSecondPrice:null,
        unitThreePrice:null,
        unitProvinceMoney:null,
        newCeoMoney:null,
        xingRoleMoney:null,
        unitCityMoney:null,
        newProvinceMoney:null,
        unitCEOMoney:null,
        unitMoney:null,
        lowMoney: null,
        roleType: null,
        ceoMoney:null,
        deposit: null,
        payMoney: null,
        checkType: null,
        content: null,
        depositMsg: null,
        provinceType:null,
        id: null,
        depositContent:null,
        provinceMoney: null,
        cityMoney: null,
        niceDisMoney:null,
        districtMoney: null,
        sendIntegral: null,
      }
    };
  },
  mounted(e) {
    //初始化表单
    var that = this;
    var good = this.$route.query.good;
    that.good = good;
    var para = {
      id: that.$route.query.id,
      token: localStorage.getItem("api_token")
    };
    if (good != null) {
      that.wordName = "修改";
      that.form.id = good.id;
      that.form.roleType = good.roleType.toString();
      that.form.lowMoney = good.lowMoney;
      that.form.payMoney = good.payMoney;
      that.form.unitMoney = good.unitMoney;
      that.form.unitThreePrice = good.unitThreePrice;
      that.form.unitSecondPrice = good.unitSecondPrice;
      if (good.sendGood != null && good.sendGood != '')
      {
        that.form.domains = JSON.parse(good.sendGood)
      }
      that.form.unitCityMoney = good.unitCityMoney;
      that.form.newProvinceMoney = good.newProvinceMoney;
      that.form.newCeoMoney = good.newCeoMoney;
      that.form.xingRoleMoney = good.xingRoleMoney;
      that.form.unitProvinceMoney = good.unitProvinceMoney;
      that.form.unitCEOMoney = good.unitCEOMoney;
      that.form.districtMoney = good.districtMoney;
      that.form.niceDisMoney = good.niceDisMoney;
      that.form.cityMoney = good.cityMoney;
      that.form.provinceMoney = good.provinceMoney;
      that.form.ceoMoney = good.ceoMoney;
      that.form.deposit = good.deposit;
      that.form.depositMsg = good.depositMsg;
      that.form.provinceType = good.provinceType == null ? null : good.provinceType + '';
      that.form.sendIntegral = good.sendIntegral;
      // that.$refs.ueditor.setContentInfo(good.depositContent);
      if (parseInt(good.roleType) > 1)
      {
        // that.$refs.ueditor1.setContentInfo(good.depositContent);
      }
    } else {
      that.form.info_type = "1";
      that.wordName = "立即创建";
    }
  },
  computed: {},
  methods: {
    removeDomain(item) {
        var index = this.form.domains.indexOf(item)
        if (index !== -1) {
          this.form.domains.splice(index, 1)
        }
      },
      addDomain() {
        this.form.domains.push({
          value: '',
          key: Date.now()
        });
      },
    beforeAvatarUpload: function(e) {},
    handleAvatarSuccess: function(e) {
      if (e.key == 1000) {
        this.form.pic = e.result.map.path;
        this.$message.success({
          showClose: true,
          message: "上传成功",
          duration: 1500
        });
      } else if (e.key == 1001) {
        bus.$emit("goto", "/login");
      }
    },
    backList() {
      this.$router.push({
        path: "/upLogList"
      });
    },

    onSubmit() {
      let that = this;
      that.$refs["form"].validate(valid => {
        if (valid) {
          let para = Object.assign({}, that.form);
          // let content = this.$refs.ueditor.getUEContent();
          // let dcontent = this.$refs.ueditor1.getUEContent();
          // para.content = content;
          // if (
          //   para.content == null ||
          //   para.content == "" ||
          //   para.content == "<p>请输入内容</p>"
          // ) {
          //   that.addLoading = false;
          //   that.$message.error({
          //     showClose: true,
          //     message: "请填写保证金协议内容",
          //     duration: 2000
          //   });
          //   return;
          // }
          // para.depositContent = dcontent;
          // if (
          //   (para.depositContent == null ||
          //   para.depositContent == "" ||
          //   para.depositContent == "<p>请输入内容</p>") && parseInt(para.roleType) > 1
          // ) {
          //   that.addLoading = false;
          //   that.$message.error({
          //     showClose: true,
          //     message: "请填写保证金协议内容",
          //     duration: 2000
          //   });
          //   return;
          // }
          var goods = para.domains;
          if (goods != null && goods.length > 0)
          {
            var send = [];
            for (var i=0; i<goods.length; i++)
            {
              if (goods[i].goodNum == null || goods[i].goodNum == '' || goods[i].infoId == null || goods[i].infoId == '')
              {
                that.$message.error({
                  showClose: true,
                  message: "请填写赠送商品的信息",
                  duration: 2000
                });
                return;
              } else {
                send.push({
                  infoId:goods[i].infoId,
                  goodNum:goods[i].goodNum
                });
              }
            }
            para.sendGood = JSON.stringify(send)
          }
          delete para.domains;
          if ((para.districtMoney == null || para.districtMoney == '') && para.roleType > 0) {
            that.$message.error({
              showClose: true,
              message: "请填写VIP门店直升金额",
              duration: 2000
            });
            return;
          }

          if ((para.niceDisMoney == null || para.niceDisMoney == '') && (para.roleType == 2 || para.roleType == 3 || para.roleType == 4)) {
            that.$message.error({
              showClose: true,
              message: "请填写优秀高级直升金额",
              duration: 2000
            });
            return;
          }


          if (
            (para.cityMoney == null || para.cityMoney == '') && para.roleType > 1
          ) {
            that.$message.error({
              showClose: true,
              message: "请填写联盟店直升金额",
              duration: 2000
            });
            return;
          }
          if (
            (para.provinceMoney == null || para.provinceMoney == '') && para.roleType > 2
          ) {
            that.$message.error({
              showClose: true,
              message: "请填写市代直升金额",
              duration: 2000
            });
            return;
          }
          if (
            (para.ceoMoney == null || para.ceoMoney == '') && para.roleType > 3
          ) {
            that.$message.error({
              showClose: true,
              message: "请填写省代直升金额",
              duration: 2000
            });
            return;
          }
          para.token = localStorage.getItem("api_token");
          that.addLoading = true;
          API.up_up_role(para)
            .then(
              function(result) {
                that.addLoading = false;
                if (result.key == 1000) {
                  if (para.id) {
                    that.$message.success({
                      showClose: true,
                      message: "修改成功",
                      duration: 1500
                    });
                  } else {
                    that.$message.success({
                      showClose: true,
                      message: "创建成功",
                      duration: 1500
                    });
                  }
                } else if (result.key == 1001) {
                  bus.$emit("goto", "/login");
                } else {
                  that.$message.error({
                    showClose: true,
                    message: result.message || "登录失败",
                    duration: 2000
                  });
                }
              },
              function(err) {
                that.loading = false;
                console.error(err);
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function(error) {
              that.loading = false;
              console.error(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
        } else {
          that.$message.error({
            showClose: true,
            message: "请检查是否有信息未填写",
            duration: 2000
          });
        }
      });
    },
    jumpTo(url) {
      this.defaultActiveIndex = url;
      this.$router.push(url); //用go刷新
    },
    resetForm() {
      let that = this;
      that.$refs["form"].resetFields();
    }
  }
};
</script>

<style>
.area-select .area-selected-trigger {
  padding: 0px 20px 7px 12px;
  line-height: 40px;
}

.main_content {
  position: absolute;
  left: 210px;
  top: 105px;
  right: 0;
  bottom: 0;
  background-color: #f2f2f2;
  padding: 0;
}
.cont_btns1 {
  float: left;
  margin: 0px 0px 20px 0;
}
.contain_header {
  background-color: #fff;
  padding: 10px;
}
.cont_btns1 li {
  display: inline-block;
}
.cont_navs {
  background-color: #fff;
  width: 100%;
  height: 55px;
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  text-align: center;
  margin-bottom: 20px;
}

.cont_navs li {
  display: inline-block;
  line-height: 21px;
  padding: 17px 0;
  margin: 0 20px;
  height: 55px;
  color: #bbb;
  font-size: 15px;
  text-align: center;
  cursor: pointer;
}

.cont_navs li:hover {
  color: #409eff;
}

.ac_li {
  color: #409eff;
  border-bottom: solid 2px #409eff;
}

.contain_div {
  margin: 20px;
}

.contain_header1 {
  background-color: #fff;
  padding: 40px 0 20px 40px;
  /* margin-bottom: 20px; */
}

.area-select {
  height: 40px;
}

.area-select-wrap .area-select {
  margin-left: 0px !important;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/dictionary/editUpRule.vue